export const OrderInboundFlowStates = [
  "INITIATED",
  "APPROVED",
  "SHIPPED",
  "RECEIVED",
];

export const OrderOutboundFlowStates = [
  "INITIATED",
  "APPROVED",
  "SHIPPED-PARTIAL",
  "SHIPPED",
  "RETURNED",
  "RETURNED-PARTIAL",
];

export const OrderExtraStates = ["CANCELLED", "MANUAL RECONCILIATION"];

export const ORDER_STATUS = Array.from(
  new Set([
    ...OrderInboundFlowStates,
    ...OrderOutboundFlowStates,
    ...OrderExtraStates,
  ]),
);

export const CONTACT_TYPE_OPTIONS = [
  {
    value: "PROCESSOR",
    label: "Processor",
  },
  {
    value: "CUSTOMER",
    label: "Customer",
  },
  {
    value: "CARRIER",
    label: "Carrier",
  },
  {
    value: "ASSISTANT",
    label: "Assistant",
  },
  {
    value: "OWNER",
    label: "Owner",
  },
  {
    value: "ADMIN",
    label: "Office-Admin",
  },
];

// Each BIN weight = 70 lbs
export const BIN_WIEGHT = 70;

// Each pallet holds = 14 BINS
export const BINS_COUNT_PER_PALLET = 14;

// Each pallet weight = 60 lbs
export const PALLET_WIEGHT = 60;

export const getOrderStatusTagColor = (status) => {
  switch (status) {
    case "INITIATED":
      return "default";
    case "APPROVED":
      return "blue";
    case "SHIPPED":
      return "gold";
    case "SHIPPED-PARTIAL":
      return "orange";
    case "RECEIVED":
      return "green";
    case "RETURNED":
      return "red";
    case "RETURNED-PARTIAL":
      return "magenta";
    case "CANCELLED":
      return "red";
    case "MANUAL RECONCILIATION":
      return "purple";
    default:
      return "default";
  }
};

export const getOrderTypeTagColor = (status) => {
  switch (status) {
    case "INBOUND":
      return "green";
    case "OUTBOUND":
      return "red";
    default:
      return "default";
  }
};
